
import { computed, defineComponent, onUnmounted, PropType, ref, watch } from 'vue'
import EmptyData from '@/views/dashboard/_components/empty-data/empty-data.vue'
import GroupPolicySettings from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.vue'
import {
  SETTING_PANE_NAMES, SettingsRes
} from '@/views/dashboard/_components/group-policy-settings/group-policy-settings.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import {
  GroupPolicyDrawerService, OperateType
} from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.service'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: { GroupPolicySettings, EmptyData },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    policyId: {
      type: String,
      default: undefined
    },
    operateType: {
      type: String as PropType<'edit'|'add'|'read'>,
      default: 'edit'
    },
    activeTab: {
      type: String,
      default: SETTING_PANE_NAMES.basicSettings
    }
  },

  setup (props, context) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([GroupPolicyDrawerService])
    const service = injector.get(GroupPolicyDrawerService)

    const policyData = ref({} as SettingsRes)

    const changePolicyDataSubscribe = service.onChangePolicyData.subscribe((response) => {
      /** 当前需求逻辑设计奇怪，这里手动保留输入框修改的内容 */
      if (policyData.value.name !== response.name && (policyData.value.name || props.operateType === OperateType.add)) {
        policyData.value = { ...response, name: policyData.value.name }
        service.changePolicyData(policyData.value)
      } else {
        policyData.value = response
      }
    })

    const title = computed(() => {
      const titleMap = {
        [OperateType.add]: t('policyManageExtra.newPolicy'),
        [OperateType.edit]: t('groupPolicySettings.drawerTitleEdit'),
        [OperateType.read]: t('groupPolicySettings.drawerTitleView'),
      }
      return titleMap[props.operateType]
    })

    function inputName () {
      service.changePolicyData(policyData.value)
    }

    function handleClose () {
      context.emit('update:modelValue', false)
      service.changePolicyData({} as any)
    }

    function handleSave () {
      context.emit('save')
      handleClose()
    }

    watch(() => props.modelValue, (val) => {
      if (val) {
        policyData.value = {} as SettingsRes
      }
    })

    onUnmounted(() => {
      changePolicyDataSubscribe.unsubscribe()
    })

    return {
      OperateType,
      policyData,
      inputName,
      title,
      handleClose,
      handleSave,
    }
  }
})
